import * as types from './mutation-types'


export const getCustomer = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/nps/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
} 

export const validateCustomerAccount = ({ commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .post(`validate/${id}/customer/account`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};




export const rejectCustomerAccount = ({ commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .delete(`reject/${id}/customer/account`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const sendNpsInvitation = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios
            .post(`send/nps/invitation`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getClienNps = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/client/${data.id}/nps?checkValidity=${data.checkValidity}&invitation=${data.invitation}`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const getNpsResponses = ({ commit, dispatch, state }, nps) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/${nps}/nps/responses/collection`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const saveNpsResponse = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios
            .post(`save/nps/response`, data) 
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const verifyNpsResponse = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios
            .post(`verify/nps/response`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getNpsResponse = ({ commit, dispatch, state }, response) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/${response}/nps/response`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getNpsStatistics = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios 
            .get(`get/${id}/nps/statistics`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
export const getNpsTotalResponse = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/${id}/nps/response/total`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getNpsTotalResponseAverage = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/${id}/nps/response/average`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
